jQuery(document).ready(function() {
	console.log("test header");

jQuery('a[href="https://www.shopify.com?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore"]').attr("aria-label","Powered by Shopify");
jQuery('img[src*="icon_etsy.png"]').attr("alt","Etsy logo");
jQuery('.logo.area--logo img').attr("alt","studio alden");

jQuery('.select__select.collection-filters__sort').removeAttr('aria-describedby');

jQuery('input[name="filter.v.price.gte"]').attr("aria-label","price of minimum");
jQuery('input[name="filter.v.price.lte"]').attr("aria-label","price to maximum");

jQuery('#mobile-Filter-Price-GTE').attr('aria-label','Minimum price');
jQuery('#mobile-Filter-Price-LTE').attr('aria-label','maximum price');

jQuery('.rte_image_block img').attr("alt","studio alden");
jQuery('#zoom img').attr("alt","");
jQuery('.substack-subscribe-embed').attr("title","subscribe form");
jQuery('#substack-frame-2280').attr("title","iframe");
jQuery('.menu-link.active, .css-slider-button, #go-top').attr("role","button");



setTimeout(function(){ 
     
jQuery('#desktop-facets-price-range-slider input').attr('aria-label', 'Price range');
jQuery('#mobile-facets-price-range-slider input').attr('aria-label', 'Price range');

     },
  1000); 



});
